export default `
fragment TaggingFragment on taggings {
  id
  userId:user_id
  tagId:tag_id
  spoiler
}
`;
